import React from 'react';
import PropTypes from 'prop-types';
import { ListGroup } from 'react-bootstrap';
import FeatureFlagRow from './FeatureFlagRow';

const FeatureFlags = props => {
  const { displayExample, flags, onToggle } = props;

  const rows = flags.map(flag => {
    return (
      <FeatureFlagRow
        flag={flag}
        key={flag.id}
        onClick={() => onToggle(flag.id)}
      />
    );
  });

  return (
    <div>
      <h2>Feature Flag DevTool</h2>
      <div className="alert alert-info">
        Toggle feature flags in this page for local development or demo. Actual
        feature flag management is available on Optimizely Rollouts.
      </div>
      <div className="alert alert-warning">
        Feature flags should work without refresh if they are within Redux. For
        global features that is out of the control of Redux, refresh is
        required.
      </div>
      <ListGroup>{rows}</ListGroup>
      {displayExample && (
        <div className="alert alert-success">
          Awesome, feature flag is working!
        </div>
      )}
    </div>
  );
};

FeatureFlags.proptypes = {
  displayExample: PropTypes.bool,
  flags: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      isEnabled: PropTypes.bool.isRequired,
    })
  ).isRequired,
  onToggle: PropTypes.func,
};

FeatureFlags.defaultProps = {
  displayExample: false,
  onToggle: () => {},
};

export default FeatureFlags;
